var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"space-between"},[_c('h2',{staticClass:"title primary-color"},[_vm._v(_vm._s(_vm.title))]),(_vm.showLanguageSelect)?_c('form-lang-switcher'):_vm._e()],1),_c('div',{staticClass:"ruler"})])
}
var staticRenderFns = []

export { render, staticRenderFns }